export const playerRoutes = [
  "NavigatorMain",
  "NavigatorHome",
  "WorkspaceExplorer",
  "NavigatorSkills",
  "NavigatorSkillPlayer",
  "NavigatorFavorites",
  "FavoritesWorkflows",
  "FavoritesWorkspaces",
  "FavoritesWorkspaceExplorer",
  "NavigatorSearch",
  "SharedMain",
  "PlayerMain",
  "PlayerMainFullscreen",
  "PublicPlayerMain",
  "PlayerFullscreenPublic",
  "UserProfileMain",
  "NavigatorWorkspaceGroup",
];

export const editSkillsRoutes = [
  "SkillsMain",
  "SkillsExplorer",
  "SkillsMatrix",
  "SkillsBuilder",
  "SkillsBuilderUsers",
  "SkillsBuilderQuizAnalytics",
  "SkillsBuilderSettings",
];

export const editorRoutes = [
  "EditorExplorer",
  "StudioWorkspaceGroup",
  "StudioWorkspace",
  "EditorExplorer",
  "EditorMain2.5",
  "Transcription",
  "Segmentation",
  "BuilderMain",
];

export const adminRoutes = [
  "AdminGroup",
  "AdminOrganization",
  "AdminMain",
  "AdminWorkspaceGroup",
  "AdminWorkspaceGroupWorkspaces",
  "AdminWorkspaceUsers",
  "AdminWorkspaceTeams",
];

export const analyticsRoutes = [
  "AnalyticsMain",
  "AnalyticsMainOrganization",
  "AnalyticsSingleWorkflow",
  "AnalyticsDataUsers",
  "AnalyticsSingleUser",
  "AnalyticsQuizWorkflows",
  "AnalyticsQuizSingleWorkflow",
  "AnalyticsQuizSingleUser",
];
